import React, { useState, useEffect } from "react";

const Counter = () => {
  const startingValue = 6529312;
  const [value, setValue] = useState(startingValue);

  const incrementValue = () => {
    const lastValue = value;
    const incrementValue = 1;

    if ((lastValue % 10) + incrementValue > 10) {
      setValue(p => 10);
    } else {
      setValue(p => p + incrementValue);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      incrementValue();
    }, 4000);

    return () => clearInterval(interval);
  }, [startingValue]);

  return (
    <div className={"shadowy-numbers"}>
      <Number number={6} />,
      <Number number={5} />
      <Number number={2} />
      <Number number={9} />,
      <Number number={Math.floor(value / 100) % 10} />
      <Number number={Math.floor(value / 10) % 10} />
      <Number number={Math.floor(value) % 10} />
    </div>
  );
};

const Number = ({ number = 0 }) => {
  const numbers = [
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten"
  ];

  return (
    <div className={"number-container"}>
      <div className={`number-place ${numbers[number]}`}>
        <span>0</span>
        <span>1</span>
        <span>2</span>
        <span>3</span>
        <span>4</span>
        <span>5</span>
        <span>6</span>
        <span>7</span>
        <span>8</span>
        <span>9</span>
        <span>0</span>
      </div>
    </div>
  );
};

export default Counter;
